// Components
import DateTime from 'react-datetime'

export default class DateTimeComponent extends DateTime {
  constructor (props) {
    super(props)
    this.handleClickOutside = this.handleOutsideClick.bind(this)
  }

  handleOutsideClick () {
    const { onClickOutside } = this.props
    onClickOutside()
  }
  // mixins: [onClickOutside]

  componentWillReceiveProps (nextProps) {
    super.componentWillReceiveProps(nextProps)

    this.setState({
      open: nextProps.open,
    })
  }
}
